// import { Checkbox, Input } from "@nextui-org/react";
// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { toast } from "react-toastify";
// import AuthLayout from "../../layouts/AuthLayout";
// import CustomButton from "../CustomButton";
// import axios from "axios";import { IoCheckmarkDoneCircle } from "react-icons/io5";

// const RequestSupplier = () => {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//   } = useForm();
//   const [show, setShow] = useState(true);

//   const onSubmit = async (data) => {
//     try {
//       let res = await axios.post(
//         `${process.env.REACT_APP_SERVER_URL}/users/supplierRequest`,
//         data
//       );
//       if (res) {
//         setShow(true);
//         localStorage.setItem("submittedReq", true);
//         toast.success("Supplier request submitted!");
//         reset();
//       }
//     } catch (error) {
//       setShow(false);
//       localStorage.setItem("submittedReq", false);
//       toast.error(error.response.data.message);
//     }
//   };

//   useEffect(() => {
//     let str = localStorage.getItem("submittedReq");
//     if (str && str === "true") {
//       setShow(true);
//     } else {
//       setShow(false);
//     }
//   }, []);

//   return (
//     <AuthLayout>
//       <div className="w-full h-full flex items-center justify-center">
//         {show ? (
//           <div className="w-full h-full flex flex-col items-center justify-center">
//             <IoCheckmarkDoneCircle className="text-green-700 text-6xl" />
//             <p className="w-[80%] mx-auto text-center mt-5 font-semibold text-lg">
//               Your request has been submitted. <br /> You will receive an email
//               once it's reviewed.
//             </p>
//           </div>
//         ) : (
//           <form
//             onSubmit={handleSubmit(onSubmit)}
//             className="w-full max-w-md bg-white p-6 rounded-2xl shadow-lg"
//           >
//             <h2 className="text-2xl font-semibold mb-6 text-center">
//               Supplier Request
//             </h2>

//             <div className="mb-4 border border-white">
//               <Input
//                 {...register("company_name", {
//                   required: "Company name is required",
//                 })}
//                 label="Company Name"
//                 variant="bordered"
//                 placeholder="Enter your company name"
//                 labelPlacement="outside"
//                 errorMessage={errors.company_name?.message}
//               />
//             </div>

//             <div className="mb-4 border border-white">
//               <Input
//                 {...register("first_name", { required: "Name is required" })}
//                 label="First Name"
//                 variant="bordered"
//                 placeholder="Enter your first name"
//                 labelPlacement="outside"
//                 errorMessage={errors.name?.message}
//               />
//             </div>
//             <div className="mb-4 border border-white ">
//               <Input
//                 {...register("last_name", { required: "Name is required" })}
//                 label="Last Name"
//                 variant="bordered"
//                 placeholder="Enter your last name"
//                 labelPlacement="outside"
//                 errorMessage={errors.name?.message}
//               />
//             </div>
//             {/* <div className="mb-4 border border-white">
//             <Input
//               {...register("phone", {
//                 required: "Phone number is required",
//                 pattern: {
//                   value: /^[0-9]{10}$/,
//                   message: "Phone number must be exactly 10 digits",
//                 },
//                 minLength: {
//                   value: 10,
//                   message: "Phone number must be exactly 10 digits",
//                 },
//                 maxLength: {
//                   value: 10,
//                   message: "Phone number must be exactly 10 digits",
//                 },
//               })}
//               label="Phone Number"
//               variant="bordered"
//               type="tel"
//               placeholder="Enter your phone number"
//               labelPlacement="outside"
//               errorMessage={errors.phone?.message}
//               onWheel={(e) => e.target.blur()}
//             />
//           </div> */}
//             <div className="mb-4 border border-white">
//               <Input
//                 {...register("phone", {
//                   required: "Phone number is required",
//                   pattern: {
//                     value: /^[0-9]{10}$/,
//                     message: "Phone number must be exactly 10 digits",
//                   },
//                 })}
//                 label="Phone Number"
//                 variant="bordered"
//                 type="tel"
//                 placeholder="Enter your phone number"
//                 labelPlacement="outside"
//                 errorMessage={errors.phone?.message}
//                 onWheel={(e) => e.target.blur()}
//                 onInput={(e) => {
//                   e.target.value = e.target.value
//                     .replace(/[^0-9]/g, "")
//                     .slice(0, 10);
//                 }}
//               />
//             </div>

//             <div className="mb-4 border border-white">
//               <Input
//                 {...register("email", {
//                   required: "Email is required",
//                   pattern: {
//                     value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
//                     message: "Enter a valid email address",
//                   },
//                 })}
//                 label="Email"
//                 variant="bordered"
//                 placeholder="Enter your email"
//                 labelPlacement="outside"
//                 errorMessage={errors.email?.message}
//               />
//             </div>
//             <div className="mb-6 border border-white">
//               <Checkbox
//                 {...register("is_capricorn_supplier")}
//                 defaultChecked={false}
//               >
//                 Are you a Capricorn supplier?
//               </Checkbox>
//             </div>
//             <CustomButton text="Submit" />
//             {/* <button
//               type="submit"
//               className="w-full bg-lightBlue hover:bg-blue-400 text-white font-semibold py-2 rounded-lg transition-colors duration-300"
//           >
//               Submit
//           </button> */}
//           </form>
//         )}
//       </div>
//     </AuthLayout>
//   );
// };

// export default RequestSupplier;

import { Checkbox, Input } from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import AuthLayout from "../../layouts/AuthLayout";
import CustomButton from "../CustomButton";
import axios from "axios";
import { IoCheckmarkDoneCircle } from "react-icons/io5";

const RequestSupplier = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  /** ⬇︎ true  → show “request submitted” screen
   *   false → show supplier request form */
  const [isPending, setIsPending] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  /* -----------------------------------------------------------
     1️⃣  Ask backend for current supplier-request status
         Expected response:
         { status: "NONE" | "PENDING" | "APPROVED" | "REJECTED" }
  ----------------------------------------------------------- */
  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/users/supplierRequest/status`,
          { signal: controller.signal }
        );
        const { status } = res.data || {};
        // treat only “PENDING” as a block; adjust if needed
        setIsPending(status === "PENDING");
      } catch (err) {
        console.error("Could not fetch supplier-request status:", err);
        setIsPending(false); // default → show form
      } finally {
        setCheckingStatus(false);
      }
    })();

    return () => controller.abort();
  }, []);

  /* -----------------------------------------------------------
     2️⃣  Handle form submission
  ----------------------------------------------------------- */
  const onSubmit = async (data) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/users/supplierRequest`,
        data
      );
      toast.success("Supplier request submitted!");
      setIsPending(true); // switch to “submitted” screen
      reset();
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    }
  };

  /* -----------------------------------------------------------
     3️⃣  UI
  ----------------------------------------------------------- */
  if (checkingStatus) return null; // spinner placeholder if you like

  return (
    <AuthLayout>
      <div className="w-full h-full flex items-center justify-center">
        {isPending ? (
          /* ------------ Success / waiting view ------------ */
          <div className="w-full h-full flex flex-col items-center justify-center">
            <IoCheckmarkDoneCircle className="text-green-700 text-6xl" />
            <p className="w-[80%] mx-auto text-center mt-5 font-semibold text-lg">
              Your request has been submitted.
              <br />
              You will receive an email once it&#39;s reviewed.
            </p>
          </div>
        ) : (
          /* ------------ Supplier Request Form ------------ */
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full max-w-md bg-white p-6 rounded-2xl shadow-lg"
          >
            <h2 className="text-2xl font-semibold mb-6 text-center">
              Supplier Request
            </h2>

            {/* Company Name */}
            <div className="mb-4">
              <Input
                {...register("company_name", {
                  required: "Company name is required",
                })}
                label="Company Name"
                variant="bordered"
                placeholder="Enter your company name"
                labelPlacement="outside"
                errorMessage={errors.company_name?.message}
              />
            </div>

            {/* First Name */}
            <div className="mb-4 border-2 border-white">
              <Input
                {...register("first_name", {
                  required: "First name is required",
                })}
                label="First Name"
                variant="bordered"
                placeholder="Enter your first name"
                labelPlacement="outside"
                errorMessage={errors.first_name?.message}
              />
            </div>

            {/* Last Name */}
            <div className="mb-4 border-2 border-white">
              <Input
                {...register("last_name", {
                  required: "Last name is required",
                })}
                label="Last Name"
                variant="bordered"
                placeholder="Enter your last name"
                labelPlacement="outside"
                errorMessage={errors.last_name?.message}
              />
            </div>

            {/* Phone */}
            <div className="mb-4 border-2 border-white">
              <Input
                {...register("phone", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Phone number must be exactly 10 digits",
                  },
                })}
                label="Phone Number"
                variant="bordered"
                type="tel"
                placeholder="Enter your phone number"
                labelPlacement="outside"
                errorMessage={errors.phone?.message}
                onWheel={(e) => e.target.blur()}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
              />
            </div>

            {/* Email */}
            <div className="mb-4 border-2 border-white">
              <Input
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Enter a valid email address",
                  },
                })}
                label="Email"
                variant="bordered"
                placeholder="Enter your email"
                labelPlacement="outside"
                errorMessage={errors.email?.message}
              />
            </div>

            {/* Capricorn Supplier Checkbox */}
            <div className="mb-6 ">
              <Checkbox {...register("is_capricorn_supplier")}>
                Are you a Capricorn supplier?
              </Checkbox>
            </div>

            <CustomButton text="Submit" />
          </form>
        )}
      </div>
    </AuthLayout>
  );
};

export default RequestSupplier;
